import * as React from "react";
import BackArrowIcon from "../../../static/images/back-arrow.svg";
import './styles.scss';

const BackButton = ({ backAction }) => {
    return (
        <img
            src={BackArrowIcon}
            alt=""
            className="back-arrow"
            onClick={(e) => {
                e.stopPropagation();
                backAction();
            }}
        />
    );
};

export { BackButton };
